import {createHttpLock} from '@raison/network-facade';
import React from 'react';
import {useLockEffect} from '~/library/network-facade';
import {RsnButton, RsnDialog} from '~/library/ui-kit';
import {DialogRegistration} from '../model/DialogRegistration';

export const registration = DialogRegistration.createNonClosable({
    name: 'SessionExpiredDialog',
    Component: ({onConfirm}: {onConfirm: () => void}) => {
        useLockEffect(SessionExpiredMsg.httpLock);

        const title = 'Session expired';
        const details =
            "You've been inactive for a while, so we logged you out for your protection. " +
            'To get back in, just start again.';
        return (
            <RsnDialog.Window placement='bottom' onClose={onConfirm}>
                <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status='attention' />}}>
                    {title}
                </RsnDialog.CenteredHeader>
                <RsnDialog.Body>{details}</RsnDialog.Body>
                <RsnDialog.Footer column>
                    <RsnButton.Primary onClick={onConfirm}>Log in again</RsnButton.Primary>
                </RsnDialog.Footer>
            </RsnDialog.Window>
        );
    },
});

export const SessionExpiredMsg = {
    ...registration,
    httpLock: createHttpLock(),
};
